import { useCallback, useContext } from 'react';

import { DataContext } from 'app/context/data';
import { DataProvider } from 'app/context/data/types';

export type ReturnTypeUseDataProvider = (
  dataProviderName?: string
) => DataProvider;

export const useDataProvider = (): ((
  dataProviderName?: string
) => DataProvider) => {
  const context = useContext(DataContext);

  const handleDataProvider = useCallback(
    (dataProviderName?: string): DataProvider => {
      if (dataProviderName) {
        const dataProvider = context?.[dataProviderName];
        if (!dataProvider) {
          throw new Error(`"${dataProviderName}" Data provider not found`);
        }

        if (dataProvider && !context?.default) {
          throw new Error(
            'If you have multiple data providers, you must provide default data provider property'
          );
        }

        return context[dataProviderName];
      }

      if (context.default) {
        return context.default as DataProvider;
      }

      throw new Error(
        `There is no "default" data provider. Please pass dataProviderName.`
      );
    },
    [context]
  );

  return handleDataProvider as (dataProviderName?: string) => DataProvider;
};
